/* eslint dot-notation: 0 */
import React, { Component, PropTypes } from 'react';

export default class ButtonBar extends Component {

  static contextTypes = {
    presenter: PropTypes.bool.isRequired,
    session: PropTypes.object.isRequired,
    deckState: PropTypes.object.isRequired,
    setMode: PropTypes.func.isRequired,
    hideHUD: PropTypes.func.isRequired,
    registerHUDRef: PropTypes.func.isRequired,
    i18n: PropTypes.func.isRequired
  };

  componentDidMount () {
    this.context.registerHUDRef('Scores', this.refs['Scores']);
    this.context.registerHUDRef('Extras', this.refs['Extras']);
    this.context.registerHUDRef('Modules', this.refs['Modules']);
    this.context.registerHUDRef('Exit', this.refs['Exit']);
    this.context.registerHUDRef('Hide', this.refs['Hide']);
  }

  clickNavBar (evt) {
    const { setMode, hideHUD } = this.context;
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.nativeEvent.stopPropagation();
      if (evt.target === this.refs.navBar) {
        setMode(null);
        hideHUD();
      }
    }
  }

  clickButton (modeName) {
    const { deckState, hideHUD, setMode } = this.context;
    const { displayHUD } = deckState;
    const newMode = modeName === 'Hide' ? null : modeName.toLowerCase();
    if (!newMode && displayHUD) {
      hideHUD();
    }
    setMode(newMode);
  }

  navBarButton (modeName) {
    const { presenter, session, i18n: _ } = this.context;
    const { mode } = session;
    let active = (mode && modeName.toLowerCase() === mode.replace(/\/.*$/, ''));
    let name = modeName;
    if (!mode && presenter && modeName === 'Hide') {
      active = true;
      name = 'Notes';
    }

    return (
      <div
          key={`btn-${modeName}`}
          className={`navbar-btn ${active ? 'active' : ''}`}
          onClick={this.clickButton.bind(this, modeName)}
          ref={modeName}>
        <button className={`btn btn-icon ${active ? 'active' : ''}`}>
          <div className={`ppa-icon-${name.toLowerCase()}`}></div>
        </button>
        <div>{_(name)}</div>
      </div>
    );
  }

  render () {
    return (
      <div
          className="teacher-remote-navbar"
          ref="navBar"
          onClick={::this.clickNavBar} >
        {
          [
            'Scores',
            'Extras',
            'Modules',
            'Exit',
            'Hide'
          ].map(modeName => this.navBarButton(modeName))
        }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/hudTeacherRemote/buttonBar.jsx